import { get, post } from '../../../../DAL/data-provider';

export const getData = async (widgetID: number) => {

    return get('/api/referfriend/get-data', {
        widgetID
    });
};

export const saveStats = async (channel: string, shortUrl: string) => {

    return post('/api/referfriend/save-stats', {
        channel,
        shortUrl,
    });
};

export const sendEmail = async (widgetID: number, shortUrl: string, from: string, to: string, message: string) => {

    return post('/api/referfriend/send-email', {
        widgetID,
        shortUrl,
        from,
        to,
        message,
    });
};